'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';

import IconButton from '@commons/components/IconButton';
import MobilePane from '@commons/components/PageLayout/Header/MobilePane';
import { SearchInput } from '@commons/components/Search/Input';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

// Type definition of the MenuPane component properties.

type Props = {
  visible: boolean;
  handleTriggerClick: () => void;
  className?: string;
};

/**
 * Search pane component.
 */

const SearchPane = ({ visible, handleTriggerClick }: Props) => {
  const t = useTranslations('search');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (visible && inputRef.current) {
      inputRef.current.focus();
    }
  }, [visible]);

  const renderedTrigger = (
    <IconButton
      type={visible ? 'close' : 'search'}
      active={visible}
      colors={{ icon: 'black', bg: 'transparent' }}
      activeColors={{ icon: 'black', bg: 'grey-1' }}
      onClick={handleTriggerClick}
      className="nav_loop_icon"
      aria-label={t('menu')}
    />
  );

  return (
    <MobilePane theme="white" trigger={renderedTrigger} visible={visible}>
      <Flex gap="xs" width={12} direction="column" marginTop="xl" marginBottom="xl">
        <Text as="h3" transform="uppercase" marginBottom="xl">
          {t('label')}
        </Text>
        <SearchInput inputReference={inputRef} />
      </Flex>
    </MobilePane>
  );
};

export default SearchPane;
